/** Where a package row comes from: the manifest, or the administrator's set. */
import type { CSSProperties } from 'react';

import type { RowOrigin } from './environment-draft.js';

const ORIGIN_TINT: Record<RowOrigin, CSSProperties> = {
  plugin: { background: 'var(--surface-fill)', color: 'var(--text-muted)' },
  declared: { background: 'var(--surface-fill)', color: 'var(--text-muted)' },
  added: { background: 'var(--ok-tint)', color: 'var(--ok)' },
  changed: { background: 'var(--info-tint)', color: 'var(--info)' },
  removed: { background: 'var(--danger-tint)', color: 'var(--danger)' },
};

export function OriginBadge({ origin, label }: { origin: RowOrigin; label?: string | undefined }) {
  return (
    <span
      className="mono"
      style={{
        display: 'inline-flex',
        flexShrink: 0,
        alignItems: 'center',
        borderRadius: 'var(--radius-badge)',
        padding: '1px 5px',
        fontSize: 'var(--text-meta-lg)',
        textTransform: 'uppercase',
        letterSpacing: '0.05em',
        ...ORIGIN_TINT[origin],
      }}
    >
      {label ?? origin}
    </span>
  );
}
